import { Button } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import Message from "../../utils/Message";

const UploadCSV = ({ report, projectId }) => {
  const [csv, setCsv] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const user = JSON.parse(localStorage.getItem('centralize-admin-data'));

  const submitCsv = async () => {
    const formData = new FormData();
    formData.append('token', user.accessToken)
    formData.append('file', csv)

    try {
      console.log(report.editEndpoint)
      const res = await axios.post(report.editEndPoint, formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (res) {
        // console.log(res)
        setCsv(null)
        setSuccessMsg('Successfully uploaded.')
      }
    } catch (error) {
      console.log(error)
      setErrorMsg(error.response.data.error)
    }
  }

  const uploadCsv = (e) => {
    const file = e.target.files[0];

    if (file && file.type !== "text/csv") {
      setErrorMsg("Please upload a csv file");
      e.target.value = null;
    }
    setCsv(file)
  };


  return (
    <div>
      {errorMsg ? <Message color="danger"> {errorMsg} </Message> : null}
      {successMsg ? <Message color="success"> {successMsg} </Message> : null}
      <div className="card-input">
        <input type="file" onChange={(e) => uploadCsv(e)} />
        <Button
          onClick={submitCsv}
          htmlType="submit"
          style={{
            backgroundColor: '#051D49',
            color: '#fff',
          }}
        >
          Submit
        </Button>
      </div>
    </div>
  )
}

export default UploadCSV